import { morphism, createSchema } from 'morphism';

const addressSchema = createSchema(
  {
    state: 'state',
    city: 'city',
    type: 'type',
    zipcode: 'zipcode',
    country: 'country'
  },
  { undefinedValues: { strip: true } }
);

const tagSchema = createSchema(
  {
    createdAt: 'createdAt',
    deleted: 'deleted',
    name: 'name',
    updatedAt: 'updatedAt',
    id: '_id'
  },
  { undefinedValues: { strip: true } }
);

const historySchema = createSchema(
  {
    action: 'action',
    timestamp: 'timestamp'
  },
  { undefinedValues: { strip: true } }
);

function pad(s) {
  return s < 10 ? '0' + s.toString() : s.toString();
}
function formatDayObject(d) {
  if (d?.day && d?.month) {
    if (d?.year) {
      return `${pad(d.month)}/${pad(d.day)}/${pad(d.year)}`;
    }

    return `${pad(d.month)}/${pad(d.day)}`;
  }

  return '';
}

export const contactSchema = createSchema(
  {
    updatedAt: 'updatedAt',
    createdAt: 'createdAt',
    id: '_id',
    anniversary: source => ({
      ...source.anniversary,
      full: formatDayObject(source.anniversary)
    }),
    birthday: source => ({
      ...source.birthday,
      full: formatDayObject(source.birthday)
    }),
    company: 'company',
    department: 'department',
    email: 'email',
    firstName: 'firstName',
    lastName: 'lastName',
    phone: 'phone',
    relation: 'relation',
    user: 'user',
    deleted: 'deleted',
    addresses: source => morphism(addressSchema, source.addresses),
    tags: source => morphism(tagSchema, source.tags),
    history: source => morphism(historySchema, source.history)
  },
  { undefinedValues: { strip: true } }
);

const tagsDataSchema = createSchema(
  {
    id: '_id',
    name: 'name',
    contactsCount: 'contactCount',
    contacts: 'contacts',
    organizationCode: 'organizationCode',
    automations: 'automations'
  },
  { undefinedValues: { strip: true } }
);

export default {
  createContact: createSchema(contactSchema, { undefinedValues: { strip: true } }),
  getContact: createSchema(contactSchema, { undefinedValues: { strip: true } }),
  updateContact: createSchema(contactSchema, { undefinedValues: { strip: true } }),
  bulkCreate: createSchema(
    {
      ok: 'ok',
      writeErrors: 'writeErrors',
      writeConcernErrors: 'writeConcernErrors',
      insertedIds: 'insertedIds',
      nInserted: 'nInserted',
      nUpserted: 'nUpserted',
      nMatched: 'nMatched',
      nModified: 'nModified',
      nRemoved: 'nRemoved',
      upserted: 'upserted'
    },
    { undefinedValues: { strip: true } }
  ),
  listContact: createSchema(
    {
      docs: source => morphism(contactSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  ),
  selectAll: createSchema(
    {
      docs: source =>
        morphism(
          {
            id: '_id'
          },
          source.docs
        ),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  ),
  listTags: createSchema(
    {
      docs: source => morphism(tagsDataSchema, source.docs),
      pagination: {
        limit: 'limit',
        page: 'page',
        pages: 'totalPages',
        total: 'totalDocs'
      }
    },
    { undefinedValues: { strip: true } }
  ),
  createTag: createSchema(
    {
      id: '_id',
      deleted: 'deleted',
      name: 'name',
      createdAt: 'createdAt',
      updatedAt: 'updatedAt'
    },
    { undefinedValues: { strip: true } }
  )
};
